import React, { useState } from 'react';
import { IStringHash } from "@models";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";

interface Props {
  options?: string[];
  option_map?: IStringHash;
  selected: string;
  extra_mapping?: { [key: string]: string };
  onSelect: (selected: string) => void;
}

export default function FloatMenu({
  options = [],
  option_map = {},
  selected,
  extra_mapping = {},
  onSelect
}: Props) {
  const [ping, setPing] = useState(false);

  const getLabelWidth = (name: string) => {
    const smallCount = 
      countOccurences(name, "i") +
      countOccurences(name, "l") +
      countOccurences(name, "I") +
      countOccurences(name, "t") +
      countOccurences(name, "r") +
      countOccurences(name, " ");

    return ((name.length - smallCount) * 10 + smallCount * 4);
  }

  const countOccurences = (searchMe: string, findMe: string) => {
    return searchMe.split(findMe).length - 1;
  }

  const return_us: any[] = [];

  let key = 0;
  options.forEach((option: string) => {
    const label = extra_mapping[option] ? `${option} ${extra_mapping[option]}` : option;
    return_us.push(
      <span key={key} style={{ float: "left" }}>
        <ToggleButtonBox 
          name={ label }
          style={{
            height: "15px",
            lineHeight: "1.5",
            border: "",
            // color: "gray",
            width: getLabelWidth(label),
            fontWeight: "bold"
          }}
          borderless
          value={ selected === option }
          onToggle={() => {
            onSelect(option);
            setPing(!ping);
          }}
        />
      </span>
    );
    key++;
  });
  Object.keys(option_map).forEach((option: string) => {
    return_us.push(
      <span key={key} style={{ float: "left" }}>
        <ToggleButtonBox 
          name={ option }
          style={{
            height: "15px",
            lineHeight: "1.5",
            border: "",
            // color: "gray",
            width: getLabelWidth(option),
            fontWeight: "bold"
          }}
          borderless
          value={ selected === option_map[option] }
          onToggle={() => {
            onSelect(option_map[option]);
            setPing(!ping);
          }}
        />
      </span>
    );
    key++;
  });
  return (<>{ return_us }</>);
}
